export default function EventCampaignDetails({eventCampaign, organization}) {
  return <div>Event campaign details!</div>
}
